/**
 * Search Tracking — captures user search intent across all 3 entry points:
 *   1. Header desktop dropdown (#hdr2NavSearchInput)
 *   2. Hero search bar (.hp-hero__search-input)
 *   3. Mobile hamburger menu (#hdr2-mobile-search-input)
 *
 * Sends 2 event types to GA4 (and Web Pixels Manager):
 *   - search_query_typed: user typed ≥3 chars + idle 1.5s (captures intent
 *     even when user later clicks an autocomplete result instead of submitting)
 *   - search_submitted: form submitted to /search (Shopify also tracks this)
 *
 * Includes 'source' dimension so you can compare which entry point performs:
 *   header / hero / mobile-menu
 *
 * No external deps. ~1.5KB minified equivalent.
 */
(function () {
  'use strict';

  var IDLE_MS = 1500;
  var MIN_LEN = 3;
  // Per-input dedupe cache (don't fire same query twice within session)
  var seen = {};

  function track(eventName, params) {
    // GA4 via gtag (already loaded by Google & YouTube App)
    if (typeof window.gtag === 'function') {
      try { window.gtag('event', eventName, params); } catch (e) {}
    }
    // dataLayer fallback (works even if gtag is loaded later)
    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      try {
        window.dataLayer.push(Object.assign({ event: eventName }, params));
      } catch (e) {}
    }
    // Shopify Web Pixels custom event
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      try { window.Shopify.analytics.publish(eventName, params); } catch (e) {}
    }
  }

  function attachInput(inputEl, source) {
    if (!inputEl) return;
    var idleTimer = null;

    inputEl.addEventListener('input', function () {
      var v = (inputEl.value || '').trim();
      clearTimeout(idleTimer);
      if (v.length < MIN_LEN) return;

      idleTimer = setTimeout(function () {
        var q = (inputEl.value || '').trim().toLowerCase();
        if (q.length < MIN_LEN) return;
        var key = source + '::' + q;
        if (seen[key]) return;
        seen[key] = true;
        track('search_query_typed', {
          search_term: q,
          search_source: source,
          page_path: window.location.pathname
        });
      }, IDLE_MS);
    });

    // Capture form submit (when present)
    var form = inputEl.form;
    if (form) {
      form.addEventListener('submit', function () {
        var q = (inputEl.value || '').trim().toLowerCase();
        if (!q) return;
        track('search_submitted', {
          search_term: q,
          search_source: source,
          page_path: window.location.pathname
        });
      });
    }

    // Capture autocomplete-result click — user clicked a suggestion,
    // submit form was skipped. Walk up to the nearest container
    // (covers all 3 entries' result-list containers).
    var resultContainers = {
      'header':      ['hdr2NavSearchResults'],
      'hero':        ['hp-hero__search-results', 'data-hp-search-results'],
      'mobile-menu': ['hdr2-mobile-search-results']
    };
    var ids = resultContainers[source] || [];
    ids.forEach(function (id) {
      var box = document.getElementById(id) || document.querySelector('[' + id + ']') || document.querySelector('.' + id);
      if (!box) return;
      box.addEventListener('click', function (e) {
        var link = e.target.closest && e.target.closest('a[href]');
        if (!link) return;
        var q = (inputEl.value || '').trim().toLowerCase();
        if (!q || q.length < MIN_LEN) return;
        track('search_autocomplete_click', {
          search_term: q,
          search_source: source,
          clicked_url: link.getAttribute('href') || '',
          page_path: window.location.pathname
        });
      }, { capture: true });
    });
  }

  /* Public hook for renderers to call when query produced zero results
     (no destination matches AND no Shopify product hits).
     Deduped per (source, query) within session — avoids spam from rerenders. */
  var zeroSeen = {};
  function zeroResults(query, source) {
    var q = (query || '').trim().toLowerCase();
    if (q.length < MIN_LEN) return;
    var key = (source || 'unknown') + '::' + q;
    if (zeroSeen[key]) return;
    zeroSeen[key] = true;
    track('search_zero_results', {
      search_term: q,
      search_source: source || 'unknown',
      page_path: window.location.pathname
    });
  }

  // expose for renderers (homepage-hero.js, predictive-search.js)
  window.__SearchTracking = { zeroResults: zeroResults };

  function init() {
    attachInput(document.querySelector('.hp-hero__search-input'), 'hero');
    attachInput(document.getElementById('hdr2NavSearchInput'),    'header');
    attachInput(document.getElementById('hdr2-mobile-search-input'), 'mobile-menu');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
